import { useAsyncOperation } from "@core/hooks/use-async-operation";
import { useNavigate } from "@core/routing/use-navigate";
import { vipRegisterManager } from "@core/service-container";
import { VeevaUserRecordData } from "@domain/veeva/veeva";
import { RoutesPath } from "@ui/navigation/routes";
import { useCallback, useEffect, useState } from "react";

interface UseVipLoginProps {
	loading: boolean;
	veevaUserData: VeevaUserRecordData | undefined;
}

export const useVipLogin = (veevaId: string | undefined): UseVipLoginProps => {
	const navigate = useNavigate();
	const [veevaUserData, setVeevaUserData] = useState<VeevaUserRecordData>();

	const fetchVeevaUser = useCallback(
		async (userId: string) => {
			try {
				const { record, emailAlreadyExists } = await vipRegisterManager.getVeevaUserData(userId);
				if (emailAlreadyExists) {
					navigate(RoutesPath.Login, { state: { email: record.email } });
				}
				setVeevaUserData(record);
			} catch (_) {
				navigate(RoutesPath.Register);
				return;
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	);

	const [fetchVeevaUserData, loading] = useAsyncOperation(fetchVeevaUser, {});

	useEffect(() => {
		veevaId && fetchVeevaUserData(veevaId);
	}, [fetchVeevaUserData, veevaId]);

	return { loading, veevaUserData };
};
